import { render, staticRenderFns } from "./AppointmentConcernTypes.vue?vue&type=template&id=2e977d9a"
import script from "./AppointmentConcernTypes.vue?vue&type=script&lang=js"
export * from "./AppointmentConcernTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports